import { Injectable } from '@angular/core';
import { SessionStateService } from './session-state.service';

const BACK_REDIRECT_KEY = 'NavigationStoreBackRedirect';

@Injectable({
  providedIn: 'root',
})
export class NavigationStore {
  constructor(private sessionStateService: SessionStateService) {}

  getBackRedirect(): (string | number)[] | null {
    return this.sessionStateService.getJson<(string | number)[]>(BACK_REDIRECT_KEY);
  }

  setBackRedirect(commands: (string | number)[]): void {
    this.sessionStateService.setJson(BACK_REDIRECT_KEY, commands);
  }

  clearBackRedirect(): void {
    this.sessionStateService.remove(BACK_REDIRECT_KEY);
  }
}
